var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeanScopeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 460",
    style: {
      enableBackground: "new 0 0 512 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v384h512V0H0z M13,13h487v358l-487.4,0.1L13,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.1,192.5h6.3c2.6,0,3.6-0.7,4.9-3.6l28.8-61.2l28.5,61.2c1.6,2.9,2.3,3.6,4.9,3.6h7c1.6,0,2.6-0.7,2.6-1.6 c0-0.7-0.3-1.3-0.7-2l-37.2-78.1c-2.3-4.9-2.9-6.3-4.7-6.3c-1.7,0-2.6,1.3-4.9,6.3l-37.1,78.1c-0.3,0.7-0.7,1.3-0.7,2 C242.7,192.2,243.5,192.5,245.1,192.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.5,181h-36c-1.3,0-1.6-0.3-1.6-1.3v-69.8c0-2-0.7-2.6-2.6-2.6h-7c-2,0-2.6,0.7-2.6,2.6V190 c0,2,0.7,2.6,2.6,2.6h47.2c2,0,2.6-0.7,2.6-2.6v-6.3C158.1,181.6,157.4,181,155.5,181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.5,189.9v-6c0-2-0.7-2.6-2.6-2.6h-42c-1,0-1.3-0.3-1.3-1.3v-21.7h24.3c1.9,0,2.9-0.3,2.9-1v-9.7 c0-0.6-1-1-2.9-1h-24.3v-26.2c-0.3-1.3,0.3-1.6,1.3-1.6h42c2,0,2.6-0.7,2.6-2.6v-6.3c0-2-0.7-2.6-2.6-2.6H175c-2,0-2.6,0.7-2.6,2.6 V190c0,2,0.7,2.6,2.6,2.6h52.9C229.9,192.5,230.5,191.9,230.5,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.8,106.2h-61.9c-2,0-2.6,0.7-2.6,2.9v80.7c0,2,0.7,2.6,2.6,2.6h7c2,0,2.6-0.7,2.6-2.6v-70.5 c0-1,0.7-1.3,1.6-1.3h39.7c1,0,1.3,0.3,1.3,1.3v70.1c0,2,0.7,2.6,2.6,2.6h7c2,0,2.6-0.7,2.6-2.6v-80.7 C407.6,106.9,406.8,106.2,404.8,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125,245.7c-8.7-2.3-12.9-4.2-12.9-9.7c0-5.4,4.5-8.7,10.9-8.7c5.7,0,10.3,2.3,14.4,5.4c0.6,0.4,1,0.6,1.3,0.6 c0.4,0,0.9-0.3,1.3-0.9l2.5-3.6c0.4-0.4,0.7-0.9,0.7-1.3s-0.3-0.7-0.9-1.3c-5.2-4.1-11.5-6.7-19.2-6.7c-11.2,0-19.9,6.4-19.9,17.2 c0,10.2,7,14.1,18.2,17c9.7,2.5,13.4,4.5,13.4,9.7c0,5.5-4.9,9-12.8,9c-6,0-11.2-2.6-15.4-6c-0.4-0.4-0.9-0.7-1.3-0.7 s-0.9,0.3-1.3,0.9l-2.5,3.5c-0.4,0.6-0.6,1-0.6,1.5c0,0.4,0.3,0.9,0.9,1.5c5.2,4.2,11.9,7.3,19.9,7.3c12.6,0,21.7-6.8,21.7-17.6 C143.4,253.3,137.5,248.9,125,245.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.4,266.1c-0.4-0.4-0.7-0.9-1.3-0.9c-0.4,0-0.9,0.3-1.5,0.7c-4.7,3.8-10.3,6.1-17,6.1 c-12.2,0-21.5-9.6-21.5-22.4c0-13.4,9.6-22.5,21.5-22.5c6.4,0,12.2,2.5,16.7,6c0.6,0.4,1,0.7,1.5,0.7c0.4,0,0.9-0.3,1.3-0.9 l2.5-3.3c0.3-0.4,0.4-0.9,0.4-1.3s-0.3-0.9-0.9-1.3c-5.5-4.7-12.9-7.8-21.4-7.8c-17.3,0-30.5,13.1-30.5,30.7s13.4,30.2,29.9,30.2 c8.4,0,16-3.1,21.8-8c0.7-0.6,1-1,1-1.5c0-0.3-0.1-0.7-0.4-1.2L209.4,266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328.8,220.1h-16.3c-1.3,0-1.9,0.4-1.9,1.9v55.2c0,1.5,0.4,1.9,1.9,1.9h4.7c1.3,0,1.9-0.4,1.9-1.9v-16.7 c0-0.7,0.3-0.9,1-0.9h8c16,0,24.7-7.3,24.7-20.2C352.6,227.1,345.1,220.1,328.8,220.1z M328.2,251.7h-8.1c-0.7,0-1-0.3-1-1v-21.5 c0-0.7,0.3-0.9,1-0.9h8.1c9.9,0,15.7,3.2,15.7,11.5C343.9,248,337.8,251.7,328.2,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.2,271.1h-24.4c-0.7,0-1-0.3-1-0.9v-15.8c0-0.7,0.3-0.9,1-0.9h21.4c1.3,0,1.9-0.4,1.9-1.9v-4.2 c0-1.5-0.4-1.9-1.9-1.9h-21.4c-0.7,0-1-0.3-1-1v-15.4c0-0.7,0.3-0.9,1-0.9h24.3c1.3,0,1.9-0.4,1.9-1.9V222c0-1.5-0.4-1.9-1.9-1.9 h-31.8c-1.3,0-1.9,0.4-1.9,1.9v55.2c0,1.5,0.4,1.9,1.9,1.9h32c1.3,0,1.9-0.4,1.9-1.9v-4.4C407.1,271.6,406.7,271.1,405.2,271.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259,219.1c-17.3,0-30.5,13.2-30.5,30.7c0,17.3,12.9,30.2,30.2,30.2c17.6,0,30.7-13.1,30.7-30.5 C289.4,232.2,276.4,219.1,259,219.1z M258.9,272c-12.2,0-21.7-9.3-21.7-22.2c0-13.2,9.7-22.5,21.8-22.5s21.8,9.2,21.8,22.4 C280.8,262.6,270.9,272,258.9,272z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 259,
    cy: 249.6,
    r: 9.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeanScopeWhite);
export default __webpack_public_path__ + "static/media/Logo.LeanScopeWhite.480b4fa89fd14e8c1e7b2253d85ad842.svg";
export { ForwardRef as ReactComponent };